module.exports = __webpack_public_path__ + "img/75684.659a7435.svg";